/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contact_Form_Fullname1Inputs */

const he_contact_form_fullname1 = /** @type {(inputs: Contact_Form_Fullname1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`שם מלא`)
};

const en_contact_form_fullname1 = /** @type {(inputs: Contact_Form_Fullname1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Full Name`)
};

/**
* | output |
* | --- |
* | "Full Name" |
*
* @param {Contact_Form_Fullname1Inputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
const contact_form_fullname1 = /** @type {((inputs?: Contact_Form_Fullname1Inputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contact_Form_Fullname1Inputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_contact_form_fullname1(inputs)
	return en_contact_form_fullname1(inputs)
});
export { contact_form_fullname1 as "contact_form_fullName" }